import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable, Subject } from 'rxjs/Rx';
import 'rxjs/add/operator/map'

@Injectable()
export class ProjectService {

  constructor(private http: Http) { }

  fetchProject(): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let body = {
      "database_id": environment.databaseID,
      "project_id": environment.projectID
    }
    return this.http.post(environment.api + 'project', body, options)
      //.map((res: Response) => res.json()[0].response);
      .map(response => {
        if (response.status === 200) return response.json()[0].response;
      })
      .catch(this.handleError);
  }

  // -----------------------------
  // Current project
  // -----------------------------

  // the currently loaded project object
  private currentProject = new Subject<any>();

  // observable project
  public currentProject$ = this.currentProject.asObservable();

  // for updating the currently loaded project
  updateCurrentProject(project: any) {
    this.currentProject.next(project);
  }
  
  private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(errMsg);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/project.service.ts